export default __webpack_public_path__ + "ec8befe65a0b98160728d5763ad3dc2b.svg";